import { render, staticRenderFns } from "./MudarInstituicao.vue?vue&type=template&id=82eb9122&scoped=true&"
import script from "./MudarInstituicao.vue?vue&type=script&lang=js&"
export * from "./MudarInstituicao.vue?vue&type=script&lang=js&"
import style0 from "./MudarInstituicao.vue?vue&type=style&index=0&id=82eb9122&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82eb9122",
  null
  
)

export default component.exports